import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { WHY_CHOOSE } from "@/data/content";

export default function WhyChooseUs() {
  return (
    <section id="why" data-testid="why-section" className="section bg-[#F8F9FA]">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7 max-w-2xl">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#0A3161]/15 bg-white px-3 py-1 text-[12px] font-semibold text-[#0A3161]">
              Why Choose IIUTCStudy
            </div>
            <h2 className="mt-4 font-display font-extrabold text-4xl md:text-5xl tracking-tight text-slate-900">
              Everything you need to go from <span className="text-[#0A3161]">learner</span> to <span className="text-[#B31942]">hired</span>.
            </h2>
            <p className="mt-4 text-slate-600 text-lg">
              Twelve reasons students and parents choose us as their long-term career partner.
            </p>
          </div>
          <div className="lg:col-span-5 grid grid-cols-3 gap-3">
            {[
              "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=400&q=80",
              "https://images.unsplash.com/photo-1571260899304-425eee4c7efc?auto=format&fit=crop&w=400&q=80",
              "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=400&q=80",
            ].map((src, i) => (
              <div
                key={src}
                className={`relative rounded-2xl overflow-hidden border border-black/5 soft-shadow ${
                  i === 1 ? "translate-y-6" : ""
                }`}
              >
                <img src={src} alt="Students in action" className="h-40 w-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A3161]/25 to-transparent" />
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {WHY_CHOOSE.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: (i % 4) * 0.06, duration: 0.45 }}
                className="group relative rounded-2xl border border-black/5 bg-white p-5 hover:-translate-y-1 transition-transform soft-shadow hover:soft-shadow-lg"
                data-testid={`why-${c.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="h-11 w-11 rounded-xl bg-[#0A3161]/10 text-[#0A3161] inline-flex items-center justify-center">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-4 text-lg font-semibold text-slate-900">{c.title}</h3>
                <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{c.desc}</p>
                <span className="absolute right-4 top-4 h-1.5 w-1.5 rounded-full bg-[#B31942] opacity-0 group-hover:opacity-100 transition-opacity" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
